import { render, staticRenderFns } from "./Newsletter.vue?vue&type=template&id=2b273fa3&"
import script from "./Newsletter.js?vue&type=script&lang=js&"
export * from "./Newsletter.js?vue&type=script&lang=js&"
import style0 from "./Newsletter.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports